// Service Dependencies
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

// App Config data
import { AppSettings } from '../../../app.config';

// Rxjs
import { Observable, throwError } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';


@Injectable()
export class IncomeDetailsService {

  apiUrl: string;

  constructor(
    private http: HttpClient,
  ) {
    this.apiUrl = AppSettings.API_PROD_ENDPOINT;
  }

  getAssetTypes(): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `asset-types`;

    return this.http.get(requesttUrl, { headers })
      .pipe(
        map((res: Response) => res)
      );
  }

  getEmployeeInfoIncomeDetailsSummary(
    employeeId: string = ''
  ): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `employee/` + employeeId + '/income-details-summary';

    return this.http.get(requesttUrl, { headers })
      .pipe(
        map((res: Response) => res)
      );
  }

  patchIncomeDetailsSummary(
    employeeId: string = '',
    incomeDetailsSummaryId: string = '',
    item: any
  ): Observable<any> {
    const body = JSON.stringify(item);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `employee/${employeeId}/income-details-summary/${incomeDetailsSummaryId}`;

    return this.http.patch(requesttUrl, body, { headers })
      .pipe(
        map((res: Response) => res),
        catchError((err: HttpErrorResponse) => {
          console.error('Status: ', err.status, ', Error: ', err.error)
          return throwError(err);
        })
      );
  }

  getEmployeeInfoIncomeDetailsSummaryConceptsByYear(
    employeeId: string = '',
    year: string = ''
  ): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `employee/` + employeeId + '/income-details-summary/' + year + '/concepts';

    return this.http.get(requesttUrl, { headers })
      .pipe(
        map((res: Response) => res)
      );
  }

  createIncomeDetailsSummary(
    id: string = '',
    item: any,
  ): Observable<any> {
    const body = JSON.stringify(item);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `employee/${id}/income-details-summary`;

    return this.http.post(requesttUrl, body, { headers })
      .pipe(
        map((res: Response) => res),
        catchError((err: HttpErrorResponse) => {
          console.error('Status: ', err.status, ', Error: ', err.error)
          return throwError(err);
        })
      );
  }


  /******************* INCOME DETAILS URBAN PROPERTY TRANSFER *****************/

  createUrbanPropertyTransfer(
    item: any,
  ): Observable<any> {
    const body = JSON.stringify(item);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `income-urban-transfer-property`;

    return this.http.post(requesttUrl, body, { headers })
      .pipe(
        map((res: Response) => res),
        catchError((err: HttpErrorResponse) => {
          console.error('Status: ', err.status, ', Error: ', err.error)
          return throwError(err);
        })
      );
  }

  updateUrbanPropertyTransfer(
    id: string = '',
    item: any,
  ): Observable<any> {
    const body = JSON.stringify(item);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `income-urban-transfer-property/${id}`;

    return this.http.put(requesttUrl, body, { headers })
      .pipe(
        map((res: Response) => res),
        catchError((err: HttpErrorResponse) => {
          console.error('Status: ', err.status, ', Error: ', err.error)
          return throwError(err);
        })
      );
  }

  /******************* INCOME DETAILS RUSTIC PROPERTY TRANSFER *****************/

  createRusticPropertyTransfer(
    item: any,
  ): Observable<any> {
    const body = JSON.stringify(item);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `income-rustic-transfer-property`;

    return this.http.post(requesttUrl, body, { headers })
      .pipe(
        map((res: Response) => res),
        catchError((err: HttpErrorResponse) => {
          console.error('Status: ', err.status, ', Error: ', err.error)
          return throwError(err);
        })
      );
  }

  updateRusticPropertyTransfer(
    id: string = '',
    item: any,
  ): Observable<any> {
    const body = JSON.stringify(item);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `income-rustic-transfer-property/${id}`;

    return this.http.put(requesttUrl, body, { headers })
      .pipe(
        map((res: Response) => res),
        catchError((err: HttpErrorResponse) => {
          console.error('Status: ', err.status, ', Error: ', err.error)
          return throwError(err);
        })
      );
  }

  /******************* INCOME DETAILS SUMMARY CONCEPTS *****************/

  createIncomeDetailsSummaryConcepts(
    id: string = '',
    year: string = '',
    item: any,
  ): Observable<any> {
    const body = JSON.stringify(item);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `employee/` + id + '/income-details-summary/' + year + '/concepts';

    return this.http.post(requesttUrl, body, { headers })
      .pipe(
        map((res: Response) => res),
        catchError((err: HttpErrorResponse) => {
          console.error('Status: ', err.status, ', Error: ', err.error)
          return throwError(err);
        })
      );
  }

  deleteIncomeDetailsSummaryConcept(
    id: string = '',
    year: string = '',
    itemId: string = '',
  ): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl +
      `employee/${id}/income-details-summary/${year}/concepts/${itemId}`;
    return this.http.delete(requesttUrl, { headers })
      .pipe(
        map((res: Response) => res),
        catchError(err => {
          console.error('Error: ' + err.error.code + ': ' +
            err.error.message + ' (' + err.status + ': ' +
            err.statusText + ')'
          );
          return throwError(err);
        })
      );
  }

  fiscalDataToDDBB(
    id: string = '',
    year: string = '',
    itemId: string = '',
    item: any,
  ): Observable<any> {
    const body = JSON.stringify(item);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl +
      `employee/${id}/income-details-summary/${year}/${itemId}`;

    return this.http.post(requesttUrl, body, { headers })
      .pipe(
        map((res: Response) => res),
        catchError((err: HttpErrorResponse) => {
          console.error('Status: ', err.status, ', Error: ', err.error)
          return throwError(err);
        })
      );
  }


  /******************** ACTIVE CONCEPTS INCOME DETAILS SUMMARY ********************/

  getAssetTypesByRegistryDesignPeriods(
    year: string = ''
  ): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `registry-design-periods/${year}`;
    console.log(requesttUrl)

    return this.http.get(requesttUrl, { headers })
      .pipe(
        map((res: Response) => res)
      );
  }


  /******************** AEAT ********************/

  getAeatAuth(
    item: any,
  ): Observable<any> {
    const body = JSON.stringify(item);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `aeat/auth`;

    return this.http.post(requesttUrl, body, { headers })
      .pipe(
        map((res: Response) => res),
        catchError((err: HttpErrorResponse) => {
          console.error('Status: ', err.status, ', Error: ', err.error)
          return throwError(err);
        })
      );
  }

  getAeatReferenceBody(
    item: any,
  ): Observable<any> {
    const body = JSON.stringify(item);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `aeat/reference-body`;

    return this.http.post(requesttUrl, body, { headers })
      .pipe(
        map((res: Response) => res),
        catchError((err: HttpErrorResponse) => {
          console.error('Status: ', err.status, ', Error: ', err.error)
          return throwError(err);
        })
      );
  }

  getAeatReference(
    item: any,
  ): Observable<any> {
    const body = JSON.stringify(item);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `aeat/reference`;

    return this.http.post(requesttUrl, body, { headers })
      .pipe(
        map((res: Response) => res),
        catchError((err: HttpErrorResponse) => {
          console.error('Status: ', err.status, ', Error: ', err.error)
          return throwError(err);
        })
      );
  }

  getAeatIsDomicileRatified(
    item: any,
  ): Observable<any> {
    const body = JSON.stringify(item);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `aeat/is-domicile-ratified`;

    return this.http.post(requesttUrl, body, { headers })
      .pipe(
        map((res: Response) => res),
        catchError((err: HttpErrorResponse) => {
          console.error('Status: ', err.status, ', Error: ', err.error)
          return throwError(err);
        })
      );
  }

  aeatRatifyDomicileNewPathWithCadastralReference(
    item: any,
  ): Observable<any> {
    const body = JSON.stringify(item);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `aeat/crawler-domicile-ratification/ratify-domicile/new-path/reference`;

    return this.http.post(requesttUrl, body, { headers })
      .pipe(
        map((res: Response) => res),
        catchError((err: HttpErrorResponse) => {
          console.error('Status: ', err.status, ', Error: ', err.error)
          return throwError(err);
        })
      );
  }

  aeatRatifyDomicileNewPathWithForm(
    item: any,
  ): Observable<any> {
    const body = JSON.stringify(item);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `aeat/crawler-domicile-ratification/ratify-domicile/new-path/form`;

    return this.http.post(requesttUrl, body, { headers })
      .pipe(
        map((res: Response) => res),
        catchError((err: HttpErrorResponse) => {
          console.error('Status: ', err.status, ', Error: ', err.error)
          return throwError(err);
        })
      );
  }

  aeatGeneratePdfFiscalData(
    item: any,
  ): Observable<any> {

    const body = JSON.stringify(item);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `aeat/crawler-fiscal-data/generate-pdf`;

    return this.http.post(requesttUrl, body, { headers: headers, responseType: 'arraybuffer' })
      .pipe(
        take(1),
        map(response => new Blob([response], { type: 'application/pdf' })),
        catchError((err: HttpErrorResponse) => {
          console.error('Status: ', err.status, ', Error: ', err.error)
          return throwError(err);
        })
      );
  }

  getAeatAuthFiscalData(
    item: any,
  ): Observable<any> {
    const body = JSON.stringify(item);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `aeat/auth/fiscal-data`;

    return this.http.post(requesttUrl, body, { headers })
      .pipe(
        map((res: Response) => res),
        catchError((err: HttpErrorResponse) => {
          console.error('Status: ', err.status, ', Error: ', err.error)
          return throwError(err);
        })
      );
  }

  checkStatus100Form(
    item: any,
  ): Observable<any> {
    const body = JSON.stringify(item);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `aeat/check-100-status`;

    return this.http.post(requesttUrl, body, { headers })
      .pipe(
        map((res: Response) => res),
        catchError((err: HttpErrorResponse) => {
          console.error('Status: ', err.status, ', Error: ', err.error)
          return throwError(err);
        })
      );
  }

  getAeatFicalData(
    item: any,
  ): Observable<any> {
    const body = JSON.stringify(item);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `aeat/fiscal-data`;

    return this.http.post(requesttUrl, body, { headers })
      .pipe(
        map((res: Response) => res),
        catchError((err: HttpErrorResponse) => {
          console.error('Status: ', err.status, ', Error: ', err.error)
          return throwError(err);
        })
      );
  }

  saveAeatFicalData(
    item: any,
    employeeId: string = '',
    incomeDetailsSummaryId: string = ''
  ): Observable<any> {
    const body = JSON.stringify(item);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `employee/` + employeeId + `/income-details/` + incomeDetailsSummaryId;

    return this.http.post(requesttUrl, body, { headers })
      .pipe(
        map((res: Response) => res),
        catchError((err: HttpErrorResponse) => {
          console.error('Status: ', err.status, ', Error: ', err.error)
          return throwError(err);
        })
      );
  }

  /******************** INCOME TABLES ********************/

  getConceptTableItems(
    endpoint: string,
    incomeDetailsSummaryId: string = ''
  ): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `${endpoint}/${incomeDetailsSummaryId}`;
    // console.log(requesttUrl)

    return this.http.get(requesttUrl, { headers })
      .pipe(
        map((res: Response) => res)
      );
  }

  createConceptTableItem(
    endpoint: string,
    item: any,
  ): Observable<any> {
    const body = JSON.stringify(item);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `${endpoint}`;

    return this.http.post(requesttUrl, body, { headers })
      .pipe(
        map((res: Response) => res),
        catchError((err: HttpErrorResponse) => {
          console.error('Status: ', err.status, ', Error: ', err.error)
          return throwError(err);
        })
      );
  }

  updateConceptTableItem(
    endpoint: string,
    id: string = '',
    item: any,
  ): Observable<any> {
    const body = JSON.stringify(item);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `${endpoint}/${id}`;

    return this.http.put(requesttUrl, body, { headers })
      .pipe(
        map((res: Response) => res),
        catchError((err: HttpErrorResponse) => {
          console.error('Status: ', err.status, ', Error: ', err.error)
          return throwError(err);
        })
      );
  }

  deleteConceptTableItem(
    endpoint: string,
    id: string = ''
  ): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `${endpoint}/${id}`;

    return this.http.delete(requesttUrl, { headers })
      .pipe(
        map((res: Response) => res),
        catchError(err => {
          console.error('Error: ' + err.error.code + ': ' +
            err.error.message + ' (' + err.status + ': ' +
            err.statusText + ')'
          );
          throw err;
        })
      );
  }


  exportFormGenerator(
    incomeDetailsSummaryId: string,
    serviceToEmployeeId: string,
    caseId: string
  ): Observable<any> {
    const body = JSON.stringify({});
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `${incomeDetailsSummaryId}/${serviceToEmployeeId}/${caseId}/export`;

    return this.http.post(requesttUrl, body, { headers })
      .pipe(
        map((res: Response) => res),
        catchError((err: HttpErrorResponse) => {
          console.error('Status: ', err.status, ', Error: ', err.error)
          return throwError(err);
        })
      );
  }

  exportIdentificationDetails(
    incomeDetailsSummaryId: string,
    serviceToEmployeeId: string,
    caseId: string
  ): Observable<any> {
    const body = JSON.stringify({});
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `${incomeDetailsSummaryId}/${serviceToEmployeeId}/${caseId}/exportIdentificationDetails`;

    return this.http.post(requesttUrl, body, { headers })
      .pipe(
        map((res: Response) => res),
        catchError((err: HttpErrorResponse) => {
          console.error('Status: ', err.status, ', Error: ', err.error)
          return throwError(err);
        })
      );
  }

  recalculateDonationCalculation(
    incomeDetailsSummaryId: string,
    serviceToEmployeeId: string,
    caseId: string
  ): Observable<any> {
    const body = JSON.stringify({});
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `${incomeDetailsSummaryId}/${serviceToEmployeeId}/${caseId}/recalculateDonationCalculation`;

    return this.http.post(requesttUrl, body, { headers })
      .pipe(
        map((res: Response) => res),
        catchError((err: HttpErrorResponse) => {
          console.error('Status: ', err.status, ', Error: ', err.error)
          return throwError(err);
        })
      );
  }


  getCadastralInformation(
    incomeDetailsSummaryId: string = ''
  ): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `income-house/cadastral/` + incomeDetailsSummaryId;

    return this.http.get(requesttUrl, { headers })
      .pipe(
        map((res: Response) => res)
      );
  }


  /***************** ENDPOITN TO SPLIT PDF *************************/
  splitInputPdf(
  ): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `296Info/playground/split-pdf`;

    return this.http.get(requesttUrl, { headers })
      .pipe(
        map((res: Response) => res)
      );
  }

  getAeatFileFromUrl(url: string): Observable<{ base64: string }> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `aeat/get-aeat-file`;

    return this.http.post<{ base64: string }>(requesttUrl, { url }, { headers })
      .pipe(
        map((res) => res),
        catchError((err: HttpErrorResponse) => {
          console.error('Status: ', err.status, ', Error: ', err.error)
          return throwError(err);
        })
      );
  }

  // ----------------------------------------------------------

  getIncomeTaxExemptKeys(): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `db-income-tax-exempt-keys`;

    return this.http.get(requesttUrl, { headers })
      .pipe(
        map((res: Response) => res)
      );
  }


  getIncomeRewardsKeys(): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `db-income-rewards-keys`;

    return this.http.get(requesttUrl, { headers })
      .pipe(
        map((res: Response) => res)
      );
  }

  getIncomeBankAccountNonResidentTypes(): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `db-income-bank-account-non-resident-types`;

    return this.http.get(requesttUrl, { headers })
      .pipe(
        map((res: Response) => res)
      );
  }

}

